import styled from "styled-components";
import * as React from "react";
import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import { useLocation } from "react-router";
import qs from "qs";

const StyledLink = styled(Link)({
  "margin-right": "1em",
});

const CustomerListPanelComponent = ({ estate }) => {
  const location = useLocation();
  const profiles = estate.customers;

  return profiles.map((profile) => {
    return (
      <StyledLink
        to={{
          pathname: location.pathname,
          search: qs.stringify({ name: profile.name }),
        }}
        key={profile.name}
      >
        <Icon name={"user"} />
        {profile.name}
      </StyledLink>
    );
  });
};

CustomerListPanelComponent.propTypes = {
  estate: PropTypes.object.isRequired,
};

export const CustomerListPanel = CustomerListPanelComponent;
